import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from './AnimatedList';
import "./Services.css";
import "./ServicePage.css";
import Banner from "../Img/Services Banner/Services Banner.jpg";

function Cargo() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <div className="service-page">
        <section className="service-hero">
          <span className="service-hero__eyebrow">Our Services</span>
          <h1 className="service-hero__title">
            Contract <span>Logistics</span>
          </h1>
          <p className="service-hero__subtitle">
            Turnkey logistics solutions for project cargo, heavy industry, construction
            and specialized shipments — under one contract, one point of accountability.
          </p>
        </section>

        <div className="service-layout">
          <article className="service-content">
            <h2>Turnkey Project Logistics</h2>
            <p>
              <strong>MMOPL</strong> specializes in turnkey contract logistics solutions that
              minimize costs and optimize resources. We have years of experience handling project
              cargoes for customers in the offshore, heavy industry, and construction sectors,
              as well as heavy-lift shipments for a wide range of industries.
            </p>

            <h2>One Contract. Complete Coverage.</h2>
            <p>
              Our contract logistics services cover the complete supply chain — from sourcing and
              warehousing to final delivery — under a single contract, giving you one point of
              accountability and one point of contact. We ensure strict quality throughout the
              project life.
            </p>

            <h2>What Contract Logistics Includes</h2>
            <ul className="service-features">
              <li>Dedicated account manager and 24/7 project support</li>
              <li>Customized SOPs aligned to your business objectives</li>
              <li>Complete documentation and compliance management</li>
              <li>Regular MIS reports and shipment tracking</li>
              <li>Scalable solutions that grow with your business</li>
              <li>Heavy-lift, ODC and multimodal project execution</li>
            </ul>

            <div className="service-info-banner">
              <div className="service-info-banner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                  <path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12" />
                </svg>
              </div>
              <p>
                <strong>Project cargo specialists:</strong> We've handled offshore, brewery,
                construction and heavy-industry shipments — no project is too complex.
              </p>
            </div>

            <div className="service-cta">
              <h3>Have a Complex Shipment?</h3>
              <p>
                Talk to our project logistics team about your cargo, timeline and site
                constraints — we'll design a solution around you.
              </p>
              <Link to="/Contact" className="service-cta__btn">
                Discuss Your Project
              </Link>
            </div>
          </article>

          <Sidebar />
        </div>
      </div>
    </>
  );
}

export default Cargo;